import { Splide } from "@splidejs/splide";
import anime from "animejs";

const directionMap = {
	tl: [-1, -1],
	t: [-1, 0],
	tr: [-1, 1],
	l: [0, -1],
	r: [0, 1],
	bl: [1, -1],
	b: [1, 0],
	br: [1, 1],
};

const DISTANCE = 200;

function getTranslateDirection(direction, distance = DISTANCE) {
	if (!directionMap.hasOwnProperty(direction)) return [1 * distance, 0];

	let dirX = directionMap[direction][1] * distance;
	let dirY = directionMap[direction][0] * distance;

	return [dirX, dirY];
}

function slideInImageWithShadow(element, direction = "t") {
	let translateDirection = getTranslateDirection(direction, 2000);
	let translateX =
		translateDirection[0] !== 0 ? translateDirection[0] : undefined;
	let translateY =
		translateDirection[1] !== 0 ? translateDirection[1] : undefined;

	anime({
		targets: element,
		opacity: [0, 1],
		translateX: [translateX, 0],
		translateY: [translateY, 0],
		easing: "easeInOutSine",
		duration: 1000,
		complete: function () {
			element.classList.add("animated-shadow");
		},
	});
}

function fadeInChildren(element, direction = "t", reverse = false) {
	let children = element.querySelectorAll(":scope > *");

	if (reverse) {
		children = Array.from(children).reverse();
	}

	let translateDirection = getTranslateDirection(direction);
	let translateX =
		translateDirection[0] !== 0 ? translateDirection[0] : undefined;
	let translateY =
		translateDirection[1] !== 0 ? translateDirection[1] : undefined;

	anime({
		targets: children,
		opacity: [0, 1],
		translateX: [translateX, 0],
		translateY: [translateY, 0],
		duration: 500,
		easing: "easeInOutSine",
		delay: anime.stagger(200),
	});
}

const timelineThumbnailSlider = document.getElementById(
	"timeline-thumbnail-slider",
);
const timelineSlider = document.getElementById("timeline-slider");

const thumbnailSlider = new Splide(timelineThumbnailSlider, {
	pagination: false,
	perPage: 7,
	perMove: 1,
	gap: "1.5rem",
	focus: "center",
	trimSpace: false,
	speed: 500,
	isNavigation: true,
	height: "130px",
	waitForTransition: true,
	fixedWidth: "6rem",
	autoHeight: true,
	breakpoints: {
		1024: {
			fixedWidth: "5rem",
			gap: "1rem",
			height: "100px",
		},
	},
});

const slider = new Splide(timelineSlider, {
	type: "fade",
	pagination: false,
	arrows: false,
	perPage: 1,
	perMove: 1,
	speed: 500,
	drag: false,
});

thumbnailSlider.on("move", (newIndex, prevIndex) => {
	const { slide } = thumbnailSlider.Components.Slides.getAt(newIndex);
	const { slide: prevSlide } =
		thumbnailSlider.Components.Slides.getAt(prevIndex);

	prevSlide.classList.add("transition-out");
	slide.classList.add("transition-in");
});

thumbnailSlider.on("moved", (newIndex, prevIndex) => {
	const { slide } = thumbnailSlider.Components.Slides.getAt(newIndex);
	const { slide: prevSlide } =
		thumbnailSlider.Components.Slides.getAt(prevIndex);

	prevSlide.classList.remove("transition-out");
	slide.classList.remove("transition-in");
});

let updateHeight = (newIndex) => {
	let slide = slider.Components.Slides.getAt(
		typeof newIndex == "number" ? newIndex : slider.index,
	).slide;
	slide.parentElement.parentElement.style.height = slide.offsetHeight + "px";
};

slider.on("active", ({ slide }) => {
	const slideImage = slide.querySelector("figure");
	const slideContent = slide.querySelector(":has(> p)");

	fadeInChildren(slideContent, "r");
	// slideInImageWithShadow(slideImage, "l");
});

slider.sync(thumbnailSlider);
slider.on("ready move resize", updateHeight);
slider.mount();
thumbnailSlider.mount();

updateHeight();
